import { useQuery } from '@tanstack/react-query';
import { fetchModoForjaSettings } from '@/services/modoforjaSettings';

export function useModoForjaSettings(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['modoforja-settings'],
    queryFn: fetchModoForjaSettings,
    staleTime: 5 * 60_000,
    enabled: options?.enabled ?? true,
  });
}
